import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-expanded"]

import { ref, computed, watch, onMounted } from "vue";
import Tile from "@/components/shared/Tile.vue";
import { useStore } from "vuex";
import Loader from "@/components/shared/Loader.vue";
import CollapsibleSection from "@/components/transitions/CollapsibleSection.vue";
import CertificationDropdown from "@/components/certification-updates/CertificationDropdown.vue";
import CertificationUpdate from "@/components/certification-updates/CertificationUpdate.vue";
import CertificationRequestDetails from "@/components/certification-updates/CertificationRequestDetails.vue";
import DisbursementSummary from "@/components/certification-updates/DisbursementSummary.vue";
import Disbursements from "@/components/certification-updates/Disbursements.vue";
import { CertificationStatusTypes } from "@/config/enums";
import { CertificationDropdownOption, CertificationModelVM } from "@/models/certificationService";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationUpdatesTile',
  props: {
    certifications: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

useStore();

const certificationRequestDetailsRef = ref<InstanceType<typeof CertificationRequestDetails> | null>(
  null,
);

const props = __props;

const certificationId = ref<number>(0);
const selectedCertification = ref();

const showAllDisbursements = ref<boolean>(false);
const gettingCertifications = ref<boolean>(true);
const loaded = ref<boolean>(false);

const certificationRequestDetailsVisible = computed<boolean>(() => {
  // if status is REQUESTED
  const statuses = [
    Number(CertificationStatusTypes.CertificationRequestPending),
    Number(CertificationStatusTypes.ReadyForCertification),
		Number(CertificationStatusTypes.SentForCertification)
  ];

  if (certificationCount.value === 0) {
    return false;
  }

  return statuses.includes(selectedCertification.value?.details?.id);
});

const certificationCount = computed<number>(() => {
  if (props.certifications && props.certifications?.length > 0) {
    return props.certifications?.length;
  }
  return 0;
});

const disbursementsCount = computed<number>(() => {
  if (selectedCertification.value) {
    return (selectedCertification.value?.disbursements || [])?.length;
  }

  return 0;
});

const currentCertification = computed(() => {
  if (props.certifications && props.certifications?.length > 0 && certificationId.value > 0) {
    return props.certifications.find(c => c.id === certificationId.value);
  }

  return props.certifications && props.certifications?.length > 0
    ? props.certifications[0]
    : undefined;
});

const certificationDropdownOptions = computed<CertificationDropdownOption[]>(() => {
  if (props.certifications) {
    return props.certifications.map((c: CertificationModelVM) => {
      return {
        id: c.id,
        amount: c.amountDisplay || "",
        sequenceNumber: c.sequenceNumber || "",
        status: c.details?.status || "",
      };
    });
  }
  return [];
});
function selectCertification(id: number) {
  certificationId.value = Number(id);
  selectedCertification.value = props.certifications?.find(c => c.id === Number(id));

  certificationRequestDetailsRef.value?.toggleDetails(false);
}

onMounted(() => {
  const certId =
    props.certifications && props.certifications?.length > 0 ? props.certifications[0]?.id : 0;
  selectCertification(certId);
});

watch(
  () => props.certifications?.length,
  (currentValue, oldValue) => {
    console.log(`certifications count update: ${oldValue} to ${currentValue}`);

    if (currentValue && currentValue > 0) {
      const certId =
        props.certifications && props.certifications?.length > 0 ? props.certifications[0]?.id : 0;
      selectCertification(certId);
      loaded.value = true;
    }
  },
);
__expose({
  gettingCertifications,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.loading)
      ? (_openBlock(), _createBlock(Tile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(Loader)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(Tile, _mergeProps(_ctx.$attrs, { class: "cert-updates-tile" }), {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(CertificationDropdown, {
            options: certificationDropdownOptions.value || [],
            selectedId: certificationId.value,
            style: {"margin-bottom":"1rem"},
            "onUpdate:certificationId": _cache[0] || (_cache[0] = ($event: any) => (selectCertification($event)))
          }, null, 8, ["options", "selectedId"]), [
            [_vShow, loaded.value && certificationCount.value > 1]
          ]),
          _createVNode(CertificationUpdate, {
            loaded: loaded.value,
            certificationCount: certificationCount.value,
            status: selectedCertification.value?.details?.status,
            showLoader: __props.loading || !loaded.value
          }, {
            description: _withCtx(() => [
              _createTextVNode(_toDisplayString(selectedCertification.value?.details?.description), 1)
            ]),
            default: _withCtx(() => [
              (certificationRequestDetailsVisible.value)
                ? (_openBlock(), _createBlock(CertificationRequestDetails, {
                    key: 0,
                    ref_key: "certificationRequestDetailsRef",
                    ref: certificationRequestDetailsRef,
                    enrollmentTerm: selectedCertification.value?.enrollmentTerm,
                    requestedAmount: selectedCertification.value?.requestedAmount,
                    schoolName: selectedCertification.value?.schoolName,
                    statusLastUpdated: selectedCertification.value?.createdAt
                  }, null, 8, ["enrollmentTerm", "requestedAmount", "schoolName", "statusLastUpdated"]))
                : _createCommentVNode("", true),
              (disbursementsCount.value > 0)
                ? (_openBlock(), _createBlock(DisbursementSummary, {
                    key: 1,
                    certification: selectedCertification.value,
                    disbursement: 
            selectedCertification.value?.disbursements?.[selectedCertification.value?.disbursements?.length - 1]
          ,
                    disbursementGroups: selectedCertification.value?.disbursementGroupsByStatus
                  }, null, 8, ["certification", "disbursement", "disbursementGroups"]))
                : _createCommentVNode("", true),
              (disbursementsCount.value > 0)
                ? (_openBlock(), _createBlock(CollapsibleSection, {
                    key: 2,
                    inverted: showAllDisbursements.value === true,
                    isVisible: showAllDisbursements.value,
                    onToggle: _cache[2] || (_cache[2] = ($event: any) => (showAllDisbursements.value = !showAllDisbursements.value))
                  }, {
                    toggle: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "link-styled-button text-underline",
                        "aria-expanded": showAllDisbursements.value ? 'true' : 'false',
                        "aria-controls": "disbursements",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showAllDisbursements.value = !showAllDisbursements.value), ["prevent"]))
                      }, _toDisplayString(showAllDisbursements.value ? "Hide" : "View") + " All ", 9, _hoisted_1)
                    ]),
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(Disbursements, {
                        id: "disbursements",
                        certification: selectedCertification.value,
                        disbursements: selectedCertification.value?.disbursements || []
                      }, null, 8, ["certification", "disbursements"]), [
                        [_vShow, showAllDisbursements.value]
                      ])
                    ]),
                    _: 1
                  }, 8, ["inverted", "isVisible"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loaded", "certificationCount", "status", "showLoader"])
        ])
      ]),
      _: 1
    }, 16), [
      [_vShow, !__props.loading]
    ])
  ], 64))
}
}

})